import config from "config";

import isPromiseLike from "./isPromiseLike";

type Profile = {
	<R>(label: string, fn: () => R): R;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(label: string): <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R;
};

const profile1 = <R>(label: string, fn: () => R): R => {
	if (config.profilingEnabled) {
		// const err = new Error();

		let async = false;
		const end = () => {
			console.timeEnd(label);
			// console.log(err.stack);
		};
		console.time(label);

		try {
			const result = fn();

			if (isPromiseLike(result)) {
				async = true;
				result.then(end, end);
			}

			return result;
		} finally {
			if (!async) {
				end();
			}
		}
	} else {
		return fn();
	}
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const profile2 = (label: string): (<A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R) => {
	if (config.profilingEnabled) {
		return fn => (...args) => profile1(label, () => fn(...args));
	} else {
		return x => x;
	}
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const profile: Profile = (label: string, fn?: any): any => (fn ? profile1(label, fn) : profile2(label));

export default profile;
